import api from './api';
import { LoginRequest, LoginResponse } from '../types';

export const authService = {
  login: (data: LoginRequest) => api.post<LoginResponse>('/auth/login', data),
};